import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ModalController, NavParams, ToastController } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';
import moment from 'moment';

import { endpoints } from 'src/app/constant/endpoints';
import { ApiService } from 'src/app/provider/api.service';
import { ConfigService } from 'src/app/provider/config.service';
import { Events } from 'src/app/provider/events.service';
import { AuthService } from 'src/app/services/auth.service';
import { Subscription } from 'rxjs';
import { AutocompletePage } from '../autocomplete/autocomplete.page';
import { AreaListsPage } from 'src/app/pages/area-lists/area-lists.page';

@Component({
  selector: 'app-edit-address',
  templateUrl: './edit-address.page.html',
  styleUrls: ['./edit-address.page.scss'],
  standalone: false,
})
export class EditAddressPage implements OnInit {
  public settings: any;
  private appSettingsSubscription: Subscription;
  customer: any;
  storeData: any = {};
  address_fields: any[] = [];
  addUpdateForm: FormGroup;
  areaSlots: any = [];
  areasOrRegion: any = [];
  areasOrRegionId: any = null;
  areasOrRegionName: string;
  areaSlotId: any = null;
  governorateId: any = null;
  addid: string;
  address: any;
  historyRoute = 'address-lists';

  address_name: string = '';
  phone: number = null;
  block: any = '';
  street: any = '';
  house_name: any = '';
  avenue: any = '';
  floor: any = '';
  flat: any = '';
  landmark: any = '';
  latitude: any = 0;
  longitude: any = 0;
  compound_code: any = '';
  global_code: any = '';
  PACI_number: any = '';
  location: any = '';
  driver_note: any = '';
  zip_code: any = '';
  notes: any = '';
  addressForm: any = {};
  is_default: any;
  constructor(
    private events: Events,
    private formBuilder: FormBuilder,
    private toastCtrl: ToastController,
    private modalCtrl: ModalController,
    private translate: TranslateService,
    private navParams: NavParams,
    private configService: ConfigService,
    private apiService: ApiService,
    private authService: AuthService,
  ) {
    this.customer = this.authService.getAuthUser();
    this.addid = this.navParams.get('addid') ? this.navParams.get('addid') : 'newAddress';
    this.apiService
      .get(endpoints.areas)
      .pipe(first())
      .subscribe((response) => {
        if (response.success) {
          this.areasOrRegion = response.data.areas;
        } else if (response.code == 401) {
          this.events.publish('user:login', { user: null, time: new Date() });
        }
      });
  }
  async ngOnInit() {
    this.storeData = await this.configService.configurationsSync();
    this.address_fields = this.storeData.address_fields;
    if (this.addid == 'newAddress') {
      this.addressForm = {}; // Initialize addressForm as an empty object first
      this.addressForm.name = "";
      this.address_fields.forEach((field) => {
        this.addressForm[field] = ''; // Or null, or a default value
      });
      this.address = {}; // Initialize addressForm as an empty object first

      this.address_fields.forEach((field) => {
        this.address[field] = ''; // Or null, or a default value
      });
    } else {
      this.apiService
        .get(endpoints.addresses + '/' + this.addid + '?customer_id=' + this.customer.id)
        .pipe(first())
        .subscribe((response) => {
          if (response.success) {
            this.addressForm = {};
            this.address = response.data.address;

            this.addressForm.latitude = this.address.latitude ? this.address.latitude : this.latitude;
            this.addressForm.longitude = this.address.longitude ? this.address.longitude : this.longitude;
            this.addressForm.areaSlotId = this.address.slot_id;
            this.addressForm.areasOrRegionId = this.address.area_id;
            this.addressForm.area = this.address.area;

            this.onAreaChange(this.address.area_id);
            this.addressForm.name = this.address.name;
            this.addressForm.phone = this.address.phone;
            this.addressForm.house_name = this.address.house_name;
            this.addressForm.block = this.address.block;
            this.addressForm.street = this.address.street;
            this.addressForm.avenue = this.address.avenue;
            this.addressForm.floor = this.address.floor;
            this.addressForm.flat = this.address.flat;

            let myJsonObject = {
              name: 'John Doe',
              age: 30,
              isStudent: false,
              courses: ['Angular', 'Ionic'],
            };

            // Convert the JSON object to a string
            let myJsonString = JSON.stringify(myJsonObject);

            if (this.address.notes == 'hello') {
              this.addressForm.landmark = myJsonString;
            } else {
              this.addressForm.landmark = this.address.landmark;
            }

            this.addressForm.PACI_number = this.address.PACI_number;
            this.addressForm.zip_code = this.address.zip_code;
            this.addressForm.location = this.address.location ? this.address.location : 'no-location';
            this.addressForm.driver_note = this.address.driver_note;
            this.addressForm.notes = this.address.notes;
          } else if (response.code == 401) {
            this.events.publish('user:login', { user: null, time: new Date() });
          }
        });
    }

    this.appSettingsSubscription = this.configService.appSettings$.subscribe((currentSettings) => {
      this.settings = currentSettings;
      this.translate.setDefaultLang(this.settings.appLanguage);
      this.translate.use(this.settings.appLanguage);
    });
    this.addressForm.customer_id = this.customer.id;
    this.addressForm.is_default = this.is_default ? this.is_default : false;
    this.onAreaChange(this.addressForm.areasOrRegionId);
    this.addressForm.slot_id = this.addressForm.areaSlotId;
  }
  ngOnDestroy() {
    if (this.appSettingsSubscription) {
      this.appSettingsSubscription.unsubscribe();
    }
  }
  onSubmitAddress = () => {
    this.addressForm.customer_id = this.customer.id;
    this.addressForm.is_default = this.is_default ? this.is_default : false;

    this.addressForm.slot_id = this.addressForm.areaSlotId;

    if (this.addid == 'newAddress') {
      let newForm = this.addressForm;

      this.apiService
        .post(endpoints.addresses, newForm)
        .pipe(first())
        .subscribe(
          (response) => {
            if (response.success) {
              this.toastMessage(response.message);
              this.modalCtrl.dismiss(true, 'close');
            } else if (response.code == 401) {
              this.events.publish('user:login', { user: null, time: new Date() });
            } else {
              this.toastMessage(response.message);
            }
          },
          (err) => {
            Object.keys(err.error).forEach((key) => {
              let errorArray = err.error[key];
              Object.keys(errorArray).forEach((index) => {
                this.toastMessage(errorArray[index]);
              });
            });
          },
        );
    } else {
      let addUpdateFormValue = this.addressForm;
      this.apiService
        .put(endpoints.addresses + '/' + this.addid, addUpdateFormValue)
        .pipe(first())
        .subscribe(
          (response) => {
            if (response.success) {
              this.toastMessage(response.message);
              this.modalCtrl.dismiss(true, 'close');
            } else if (response.code == 401) {
              this.events.publish('user:login', { user: null, time: new Date() });
            } else {
              this.toastMessage(response.message);
            }
          },
          (err) => {
            Object.keys(err.error).forEach((key) => {
              let errorArray = err.error[key];
              Object.keys(errorArray).forEach((index) => {
                this.toastMessage(errorArray[index]);
              });
            });
          },
        );
    }
  };
  openAreaModal = async () => {
    const areaModal = await this.modalCtrl.create({
      component: AreaListsPage,
      componentProps: {
        citylist: this.areasOrRegion,
        orginallist: this.areasOrRegion,
      },
    });
    areaModal.onDidDismiss().then((data) => {
      if (data.data) {
        this.addressForm.area_id = data.data.id;
        this.addressForm.area = this.settings.appLanguage == 'ar' ? data.data.a_title : data.data.title;

        this.onAreaChange(data.data.id);
      }
    });
    return areaModal.present();
  };
  onAreaChange = (area_id: any) => {
    this.apiService
      .get(endpoints.slots + '?area_id=' + area_id)
      .pipe(first())
      .subscribe((response) => {
        if (response.success) {
          this.areaSlots = response.data.slots;

          this.areaSlots.forEach((data) => {
            data.delivery_start_time = moment(data.start_time, 'HH:mm:ss').format('hh:mm A');
            data.delivery_end_time = moment(data.end_time, 'HH:mm:ss').format('hh:mm A');
          });
        } else if (response.code == 401) {
          this.events.publish('user:login', { user: null, time: new Date() });
        }
      });
    this.areasOrRegion.map((area) => {
      if (area.id == area_id) {
        this.addressForm.governorate_id = area.governorate_id;
      }
    });
  };
  toastMessage = async (msg) => {
    await this.toastCtrl
      .create({
        message: this.translate.instant(msg),
        duration: 4000,
        position: 'top',
        color: 'light',
      })
      .then((toastElem) => toastElem.present());
  };
  numberValidation = (event: any) => {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    if (event.target.value.length > 7) {
      event.target.value = event.target.value.slice(0, 7);
    }
    return true;
  };
  openMap = async () => {
    const mapModal = await this.modalCtrl.create({
      component: AutocompletePage,
      componentProps: {
        latitude: this.latitude,
        longitude: this.longitude,
        compound_code: this.compound_code,
        global_code: this.global_code,
      },
    });
    mapModal.onDidDismiss().then((result) => {
      if (result.data) {
        this.latitude = result.data.latitude;
        this.longitude = result.data.longitude;
        this.compound_code = result.data.compound_code;
        this.global_code = result.data.global_code;
      }
    });
    return mapModal.present();
  };
  closeModal = () => {
    this.modalCtrl.dismiss(null, 'cancel');
  };
}
